<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title v-ripple style="cursor: pointer" @click="fetchData(onlyTrashed)">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">Fornecedores {{onlyTrashed ? ' removidos' : ''}}</span>
                    </template>
                    <span>Clique para actualizar</span>
                </v-tooltip>
            </v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="mr-2 mb-2" fill-height
                  v-model="search"
                  append-icon="search"
                  label="procurar fornecedores..."
                  clearable
                  single-line
                  hide-details
            ></v-text-field>

            <v-btn v-if="!onlyTrashed && permissionToAdd" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
            <provider-form-modal
                :active_states="active_states"
                :categories="categories"
                :subcategories="subcategories"
                :cities="cities"
                :companyTypes="companyTypes"
                @onFormProviderDone="fetchData()"
            ></provider-form-modal>
        </v-toolbar>


        <v-data-table xs12 sm6 md4
            :headers="headers"
            :items="providers"
            :loading="loading"
            class="elevation-1"
            :no-data-text="noDataText()"
            :rows-per-page-items="Global.ROWS_PER_PAGE"
            no-results-text="nenhum resultado"
            rows-per-page-text="por página"
            :pagination.sync="pagination"
            hide-actions
            disable-initial-sort
        >
            <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" >
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.nif }}</td>
                <td class="text-xs-right">{{getClientCategoryName(props.item.category_id)}}</td>
                <td class="text-xs-right">{{getClientSubCategoryName(props.item.subcategory_id)}}</td>
                <td class="text-xs-center">{{ props.item.address ? props.item.address : 'indefinido'}}</td>
                <td class="text-xs-center"><v-chip small outline :color="props.item.active_state ? 'green' : 'red'">{{ props.item.active_state ? 'ativo' : 'inativo' }}</v-chip></td>
                <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                <td class="text-xs-right" style="min-width: 120px; padding-right: 10px;">
                    <v-icon v-if="!onlyTrashed" small class="mr-2" @click="showItem(props.item)">visibility</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToUpdate" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon v-if="!onlyTrashed && permissionToDelete" small class="mr-2" @click="deleteItem(props.item)">block</v-icon>
                    <v-icon v-if="onlyTrashed" small class="mr-2" @click="restoreTrashedItem(props.item)">replay</v-icon>
                    <!--<v-icon v-if="onlyTrashed" small class="mr-2" @click="deleteTrashedItem(props.item)">delete</v-icon>-->
                </td>
            </template>
            <template v-slot:footer>
                <td :colspan="headers.length">
                    <custom-pagination
                        :totalData="totalData"
                        @onPaginationChange="paginationChangeCallBack($event)"
                        :disabled="loading"
                    ></custom-pagination>
                </td>
            </template>
            <template v-if="error_fetching" slot="no-data">
                <v-btn flat color="primary" @click="fetchData(onlyTrashed)"><v-icon>refresh</v-icon></v-btn>
                <span class="text-xs-center">nenhum dado encontrado</span>
            </template>
        </v-data-table>

        <v-dialog persistent max-width="290" v-model="openConfirmationDialog" @close="openConfirmationDialog = false">
            <v-card>

                <v-card-text class="text-xs-center">
                    <p v-if="confirmationModalOp === 1">Tens a certeza que queres eliminar <br> <b>{{selectedProvider.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 2">Tens a certeza que queres <br> <span class="green--text text--darken-2">restaurar</span> <br><b>{{selectedProvider.name}}</b>?</p>
                    <p v-if="confirmationModalOp === 3">Tens a certeza que queres <br> <span class="red--text text--darken-2">eliminar permanentemente</span> <br><b>{{selectedProvider.name}}</b>?</p>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn color="red darken-1" flat @click="confirmationDialogYes">Sim</v-btn>
                        <v-btn color="grey darken-1" flat @click="close">Não</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn @click="fetchData(!onlyTrashed)" slot="activator" dark small :color="onlyTrashed ? 'red' : 'indigo'">
            {{onlyTrashed ? 'Sair de ' : ''}}Fornecedores removidas
        </v-btn>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {Permissions, Global} from "../../config";
    import CustomPagination from '../extra/CustomPagination.vue';

    import {eventBus} from "../../main";

    import ProviderFormModal from '../provider/FormModal.vue';

    export default {
        created () {
            this.providers = [];
        },

        beforeDestroy(){
            this.close();
        },

        data(){
            return {
                Global,
                Permissions,
                pagination: {},
                totalData: 0,
                loading: false, //loading for list of providers in the datatable
                loading_modal: false, //loading for the action buttons in form modal
                error_fetching: false,  //error for fetching list of providers in the datatable
                search: '', //search for the datatable
                openConfirmationDialog: false, //loads confirmation modal with yes or no
                headers: [
                    { text: 'Nome', align: 'left', value: 'name' },
                    { text: 'Nif', align: 'center', value: 'nif'},
                    { text: 'Categoria', align: 'center', value: 'category_name'},
                    { text: 'SubCategoria', align: 'center', value: 'subcategory_name'},
                    { text: 'Local', align: 'center', value: 'address' },
                    { text: 'Estado', align: 'center', value: 'active_state' },
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Ações', align: 'right', value: '', sortable: false }
                ],

                providers: [],
                cities: [],
                companyTypes: [],
                active_states: [{id: 0, name: 'inativo'}, {id: 1, name: 'ativo'}],
                selectedIndex: -1, //the index of the selected provider, useful for delete, add, update, restore, permanently delete
                onlyTrashed: false, //displays only trashed items or not
                confirmationModalOp: 0, //used for getting the confirmation actions (delete, restore, permanently delete) from confirmation modal
                newContactName: '', //used in contact tab to add a new contact

                categories: [],
                subcategories: [],
            }
        },

        watch: {
            pagination(){
                this.fetchData();
            },
            search() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.fetchData();
                }, 800);
            },
        },

        components: {
            ProviderFormModal,
            CustomPagination,
            // ConfirmationDialog,
        },

        computed: {
            ...mapGetters([
                'getNewProvider',
                'getNewCompany',
                'getToken'
            ]),
            permissionToAdd(){
                return this.hasPermission(Permissions.PROVIDER_ADD);
            },
            permissionToUpdate(){
                return this.hasPermission(Permissions.PROVIDER_UPDATE);
            },
            permissionToDelete(){
                return this.hasPermission(Permissions.PROVIDER_DELETE);
            },
            showProviderModal: {
                get(){
                    return this.$store.getters.getShowProviderModal;
                },
                set(value){
                    this.$store.dispatch('setShowProviderModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            selectedProvider: {
                get(){
                    return this.$store.getters.getSelectedProvider;
                },
                set(value){
                    this.$store.dispatch('setSelectedProvider', value);
                }
            },
            providerShow: {
                get(){
                    return this.$store.getters.getProviderShow;
                },
                set(value){
                    this.$store.dispatch('setProviderShow', value);
                }
            },
        },

        methods: {

            paginationChangeCallBack(payload){
                this.pagination.rowsPerPage = payload.byPage;
                this.pagination.page = payload.currentPage;
                this.fetchData();
            },

            getClientCategoryName(clientCategoryId){
                for(let i=0; i<this.categories.length; i++){
                    if(this.categories[i].id === clientCategoryId){
                        return this.categories[i].name;
                    }
                }
                return '---';
            },

            getClientSubCategoryName(clientSubCategoryId){
                for(let i=0; i<this.subcategories.length; i++){
                    if(this.subcategories[i].id === clientSubCategoryId){
                        return this.subcategories[i].name;
                    }
                }
                return '---';
            },
            noDataText(){
                return this.loading ? 'a carregar fornecedores ...' : 
                        this.onlyTrashed ? 'Nenhum Fornecedor removido.' : 'nenhum fornecedor.';
            },

            fetchData(onlyTrashed = false){
                if(this.loading) return;
                try{
                    this.onlyTrashed = onlyTrashed;
                    let url = onlyTrashed ? 'provider/trashed' : 'provider';

                    this.providers = [];
                    this.loading = true;
                    this.error_fetching = false;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.get(url, {
                        params: {
                            pag_size: this.pagination.rowsPerPage,
                            pag_current: this.pagination.page,
                            sort_field: this.getSortBy(this.pagination),
                            sort_order: this.getSortDes(this.pagination),
                            search: this.search,
                        }
                    })
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.error_fetching = true;
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        if(!this.isOkFromServer(response)){
                            return;
                        }

                        if(onlyTrashed){
                            // this.setProviders(response.data.response);
                            this.providers = response.data.response;
                        }else {
                            this.providers = response.data.response.providers;
                            this.cities = response.data.response.cities;
                            this.companyTypes = response.data.response.companyTypes;
                            this.categories = response.data.response.providerCategory;
                            this.subcategories = response.data.response.providerSubcategory;

                            this.totalData = response.data.response.total_data;
                        }

                    }).catch(error => {
                        // this.consoleLog(error);
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de fornecedores.!', 'error');
                    }).finally(()=>{
                        this.loading = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao carregar lista de fornecedores!', 'error');
                    this.loading_modal = false;
                }
            },

            delete(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedProvider.name;
                    Vue.axios.delete('provider/'+this.selectedProvider.id)
                    .then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        if(response.data.response === 'notAuthorized'){
                            this.showSnackBar('Não tens permissão.', 'info');
                            return;
                        }
                        this.providers.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' removido com sucesso', 'success');
                    }).catch(error => {
                        this.consoleLog(error);
                        this.showSnackBar('Ocorreu um erro ao remover fornecedor', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedProvider = this.getNewProvider;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao remover fornecedor!', 'error');
                    this.loading_modal = false;
                }
            },

            restoreTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedProvider.name;
                    Vue.axios.put('provider/trashed/restore/'+this.selectedProvider.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.providers.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+' restaurado com sucesso', 'success');
                    }).catch(error => {
                        // this.consoleLog(error);
                        this.showSnackBar('Erro ao restaurar fornecedor', 'error');
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedProvider = this.getNewProvider;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao restaurar fornecedor!', 'error');
                    this.loading_modal = false;
                }
            },

            deleteTrashed(){
                try{
                    this.loading_modal = true;
                    let name = this.selectedProvider.name;
                    Vue.axios.delete('provider/trashed/delete/'+this.selectedProvider.id)
                    .then(response => {
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            this.loading_modal = false;
                            return;
                        }
                        this.providers.splice(this.selectedIndex, 1);
                        this.showSnackBar(name+ ' foi eliminado permanentemente com sucesso', 'success');
                    }).catch(error => {
                        this.showSnackBar('Erro ao eliminar permanentemente o fornecedor', 'error');
                        // this.consoleLog(error);
                    }).finally( ()=> {
                        this.loading_modal = false;
                        this.openConfirmationDialog = false;
                        this.selectedIndex = -1;
                        this.selectedProvider = this.getNewProvider;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao eliminar permanentemente a fornecedor!', 'error');
                    this.loading_modal =false;
                    // this.consoleLog(e);
                }
            },

            getContactsJson(item){
                if(!item.contacts_json) return [];
                if(item.contacts_json instanceof Array)
                    return item.contacts_json;
                else
                    return JSON.parse(item.contacts_json);
            },

            showItem (item) {
                this.providerShow = true;
                this.selectedIndex = this.providers.indexOf(item);
                this.selectedProvider = item;
                this.selectedProvider.contacts_json = this.getContactsJson(item);
                eventBus.$emit('onProviderModalOpen', true);
                this.showProviderModal = true;
            },

            editItem (item) {
                this.selectedIndex = this.providers.indexOf(item);
                this.selectedProvider = item;
                this.selectedProvider.contacts_json = this.getContactsJson(item);
                eventBus.$emit('onProviderModalOpen', true);
                this.showProviderModal = true;
                console.log('selectedProvider', this.selectedProvider)
            },

            deleteItem (item) {
                this.confirmationModalOp = 1;
                this.selectedIndex = this.providers.indexOf(item);
                // this.$store.dispatch('setSelectedProvider', item);
                this.selectedProvider = item;
                this.selectedProvider.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            restoreTrashedItem (item){
                this.confirmationModalOp = 2;
                this.selectedIndex = this.providers.indexOf(item);
                this.selectedProvider = item;
                this.selectedProvider.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            deleteTrashedItem (item){
                this.confirmationModalOp = 3;
                this.selectedIndex = this.providers.indexOf(item);
                this.selectedProvider = item;
                this.selectedProvider.contacts_json = this.getContactsJson(item);
                this.openConfirmationDialog = true;
            },

            close () {
                this.showProviderModal = false;
                this.openConfirmationDialog = false;
                this.loading = false;
                this.newContactName = '';
                this.providerShow = false;
                if(this.$v) this.$v.$reset();
                setTimeout(() => {
                    this.selectedProvider = this.getNewProvider;
                    this.selectedIndex = -1
                }, 300)
            },

            openModal(){
                this.selectedProvider = this.getNewProvider;
                this.showProviderModal = true;
                eventBus.$emit('onProviderModalOpen', true);
            },

            getNewEmptyContact(){
                return { phone: '', mobile_phone: '', email: '', fax: ''}
            },

            confirmationDialogYes(){
                if(this.confirmationModalOp === 1){
                    this.delete();
                }else if(this.confirmationModalOp === 2){
                    this.restoreTrashed();
                }else if(this.confirmationModalOp === 3){
                    this.deleteTrashed();
                }
            },

        },


    }
</script>

<style scoped>
    .mborder {
        border: 1px solid black;
    }
</style>